import postCategory from '../data/postCategory/postCategory.json';
import { PostSubcategory } from '../domain/postCategories';

type Categorytype = {
  category: PostSubcategory;
  thai_name: string;
};

export function getPostCategoryLabel(category: PostSubcategory): {
  category?: string;
  thai_name?: string;
} {
  const matchedCategory = (postCategory as Categorytype[]).find(
    (item) => item.category === category,
  );

  if (!matchedCategory) return {};

  return {
    thai_name: matchedCategory.thai_name,
  };
}
